<div #risk_matrix_ref class="risk-matrix">
  <table *ngIf="isValid5x5Array(gridData)">
    <tr>
      <th></th>
      <th class="{{ enableInteractiveMode && riskData?.likelihood == 1 ? 'selected' : '' }}">Rare</th>
      <th class="{{ enableInteractiveMode && riskData?.likelihood == 2 ? 'selected' : '' }}">Unlikely</th>
      <th class="{{ enableInteractiveMode && riskData?.likelihood == 3 ? 'selected' : '' }}">Possible</th>
      <th class="{{ enableInteractiveMode && riskData?.likelihood == 4 ? 'selected' : '' }}">Likely</th>
      <th class="{{ enableInteractiveMode && riskData?.likelihood == 5 ? 'selected' : '' }}">Almost Certain</th>
    </tr>

    <tr *ngFor="let row of gridData; let i_severity = index;">
      <th class="{{ enableInteractiveMode && riskData?.severity == (5 - i_severity) ? 'selected' : '' }}">{{ utils.getRiskAssessmentSeverityList().reverse()[i_severity] }}</th>
      <td
        *ngFor="let col of gridData[i_severity]; let j_likelihood = index"
        class="{{ getBackgroundColors(utils.getRiskAssessmentText(j_likelihood+1, getSeverityIndexInReverseOrder(i_severity)+1)) }}"
        (click)="onSelectRiskLevel(j_likelihood+1, getSeverityIndexInReverseOrder(i_severity)+1)"
      >
        <div class="cell-content">
          <span class="cell-label">{{ ((getSeverityIndexInReverseOrder(i_severity)+1) * (j_likelihood+1)) }}: {{ utils.getRiskAssessmentText(j_likelihood+1, getSeverityIndexInReverseOrder(i_severity)+1) }}</span>
          <span class="cell-count" *ngIf="!enableInteractiveMode && gridData[i_severity][j_likelihood]">{{ gridData[i_severity][j_likelihood] }}</span>
        </div>
      </td>
    </tr>
  </table>
</div>
